const messages = {
  "User does not exist.": "El usuario no existe",
  "Incorrect username or password.": "Usuario o contraseña incorrecto",
  "User is disabled.":
    "Usuario inactivado. Contacta a tu asesor para verificar el estado de tu cuenta",
  // Amplify v6 sign-in steps that need the user to act; authUser fails with the step name
  CONFIRM_SIGN_UP: "Tu cuenta aún no está confirmada. Revisa tu correo para confirmarla.",
  RESET_PASSWORD: "Necesitas restablecer tu contraseña. Usa «¿Olvidaste tu contraseña?».",
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED:
    "Necesitas crear una contraseña nueva. Usa «¿Olvidaste tu contraseña?».",
};

export default messages;
